import React from 'react';
import Box from './Box';
import { MdDone, MdOutlineDescription, MdOutlineWarningAmber } from 'react-icons/md';
import { Trans, useTranslation } from 'react-i18next';
import ToKnowAboutSM from './ToKnowAboutSM';

export default function HowItWorks() {
    const { t } = useTranslation();
    return (
        <div className={'margin my-10'}>
            <h1 className={'mb-5 text-center font-medium '}>
                {t('translation:HOW_IT_WORKS.3_STEPS_TO_SM')}
            </h1>
            <div className={'flex flex-wrap justify-center gap-5'}>
                <Box
                    icon={<MdOutlineWarningAmber />}
                    title={t('translation:HOW_IT_WORKS.BOX.1_TITLE')}
                    step={1}
                    content={t('translation:HOW_IT_WORKS.BOX.1_CONTENT')}
                />
                <Box
                    icon={<MdOutlineDescription />}
                    title={t('translation:HOW_IT_WORKS.BOX.2_TITLE')}
                    step={2}
                    content={t('translation:HOW_IT_WORKS.BOX.2_CONTENT')}
                />
                <Box
                    icon={<MdDone />}
                    title={t('translation:HOW_IT_WORKS.BOX.3_TITLE')}
                    step={3}
                    content={t('translation:HOW_IT_WORKS.BOX.3_CONTENT')}
                />
            </div>

            <div className={'mt-10'}>
                <h1 className={'my-5 text-center font-medium'}>
                    {t('translation:HOW_IT_WORKS.FAQ.TITLE')}
                </h1>

                <ToKnowAboutSM header={t('translation:HOW_IT_WORKS.FAQ.1.TITLE')}>
                    {t('translation:HOW_IT_WORKS.FAQ.1.CONTENT')}
                </ToKnowAboutSM>

                <ToKnowAboutSM header={t('translation:HOW_IT_WORKS.FAQ.2.TITLE')}>
                    {t('translation:HOW_IT_WORKS.FAQ.2.CONTENT')}
                </ToKnowAboutSM>

                <ToKnowAboutSM header={t('translation:HOW_IT_WORKS.FAQ.3.TITLE')}>
                    {t('translation:HOW_IT_WORKS.FAQ.3.CONTENT')}
                </ToKnowAboutSM>

                <ToKnowAboutSM header={t('translation:HOW_IT_WORKS.FAQ.4.TITLE')}>
                    <Trans i18nKey={'translation:HOW_IT_WORKS.FAQ.4.CONTENT'} />
                </ToKnowAboutSM>

                <ToKnowAboutSM header={t('translation:HOW_IT_WORKS.FAQ.5.TITLE')}>
                    {t('translation:HOW_IT_WORKS.FAQ.5.CONTENT')}
                </ToKnowAboutSM>
            </div>
        </div>
    );
}
